var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "generateCert" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "contentBox",
        attrs: {
          "element-loading-text": "生成证书中...",
          "element-loading-spinner": "el-icon-loading",
          "element-loading-background": "rgba(0, 0, 0, 0.7)"
        }
      },
      [
        _c(
          "div",
          { staticClass: "info" },
          [
            _c(
              "el-form",
              {
                ref: "CertForm",
                attrs: { model: _vm.CertForm, rules: _vm.rules }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "220px",
                      label: "您的姓名",
                      prop: "name"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入姓名", clearable: "" },
                      model: {
                        value: _vm.CertForm.name,
                        callback: function($$v) {
                          _vm.$set(_vm.CertForm, "name", $$v)
                        },
                        expression: "CertForm.name"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("您的姓名将会显示在证书上")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "220px",
                      label: "手机号/账号",
                      prop: "tel"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入您的常用手机号或您已有的ICode账号",
                        clearable: ""
                      },
                      model: {
                        value: _vm.CertForm.tel,
                        callback: function($$v) {
                          _vm.$set(_vm.CertForm, "tel", $$v)
                        },
                        expression: "CertForm.tel"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "使用该手机号或账号登录ICode平台，可永久保存并下载此证书"
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.submitForm("CertForm")
                }
              }
            },
            [_vm._v("生成证书")]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("h1", [_vm._v("生成证书")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-207c26ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-207c26ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ohcGenerateCert.vue
// module id = null
// module chunks = 